"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockData = void 0;
const mockData = exports.mockData = {
  code: 0,
  msg: 'ok',
  requestId: '9bd2e59fbe6a488589e0138f89ecfb45',
  data: [{
    eventId: 'E202305311412162179',
    ecId: 'EC202305311435016085',
    commodityId: 'C202305311435013157',
    commodityType: 20,
    commodityName: 'VOD-个人体验包',
    totalNum: 20,
    drawNum: 0,
    userLimitNum: 1,
    couponInfo: null,
    discountInfo: {
      minPurchaseNum: 0,
      maxPurchaseNum: 0,
      timeInfoList: [{
        timeSpan: 1,
        timeUnit: 2
      }],
      regionInfoList: [],
      defPrice: 14,
      defOriginPrice: 14,
      platformType: '',
      skuInfoList: [{
        timeUnit: 2,
        timeSpan: 1,
        regionId: 470004,
        skuId: 'DS202305311446466222',
        priceParam: '{"tape":"sv_vod_vod_package_newhand_individual","timeSpanUnit":"1m"}'
      }],
      bluePrintList: [],
      moduleCode: 'vod_v5',
      spuInfo: '{"tape":{"option":["sv_vod_vod_package_newhand_individual"]},"timeSpanUnit":{"option":["1m"]}}'
    }
  }, {
    eventId: 'E202304100941471634',
    ecId: 'EC202304101125106010',
    commodityId: 'C202304101125106767',
    commodityType: 20,
    commodityName: '折扣商品04101121',
    totalNum: 3,
    drawNum: 0,
    userLimitNum: 2,
    couponInfo: null,
    discountInfo: {
      minPurchaseNum: 1,
      maxPurchaseNum: 2,
      timeInfoList: [{
        timeSpan: 1,
        timeUnit: 7
      }],
      regionInfoList: [{
        regionId: 47,
        regionEnName: 'others',
        regionCnName: '其他'
      }],
      defPrice: 671,
      defOriginPrice: 1343,
      platformType: '',
      skuInfoList: [{
        timeUnit: 7,
        timeSpan: 1,
        regionId: 47,
        skuId: 'DS202304101125511274',
        priceParam: '{"goodsNum":1,"pkgType":"sv_live_transpack_100h","resourceType":"sp_live_transpack"}'
      }],
      bluePrintList: [],
      moduleCode: 'live_v3',
      spuInfo: '{"goodsNum":{"range":{"max":2,"min":1,"step":1}},"pkgType":{"constraint":{"field":["resourceType"],"value":{"sp_live_transpack":["sv_live_transpack_100h"]}}},"resourceType":{"option":["sp_live_transpack"]}}'
    }
  }, {
    eventId: 'E202304141521206053',
    ecId: 'EC202304141522175520',
    commodityId: 'C202304141522179398',
    commodityType: 20,
    commodityName: 'test1',
    totalNum: 20,
    drawNum: 0,
    userLimitNum: 10,
    couponInfo: null,
    discountInfo: {
      minPurchaseNum: 1,
      maxPurchaseNum: 20,
      timeInfoList: [{
        timeSpan: 1,
        timeUnit: 7
      }],
      regionInfoList: [{
        regionId: 47,
        regionEnName: 'others',
        regionCnName: '其他'
      }],
      defPrice: 388,
      defOriginPrice: 388,
      platformType: '',
      skuInfoList: [{
        timeUnit: 7,
        timeSpan: 1,
        regionId: 47,
        skuId: 'DS202304141608545228',
        priceParam: '{"goodsNum":1,"pkgType":"sv_live_prepaid_traffic_100","resourceType":"sp_live_prepaid_resources"}'
      }, {
        timeUnit: 7,
        timeSpan: 1,
        regionId: 47,
        skuId: 'DS202304141608541555',
        priceParam: '{"goodsNum":1,"pkgType":"sv_live_prepaid_traffic_500","resourceType":"sp_live_prepaid_resources"}'
      }],
      bluePrintList: [],
      moduleCode: 'live_v2',
      spuInfo: '{"goodsNum":{"range":{"max":20,"min":1,"step":0}},"pkgType":{"constraint":{"field":["resourceType"],"value":{"sp_live_prepaid_resources":["sv_live_prepaid_traffic_100","sv_live_prepaid_traffic_500"]}}},"resourceType":{"option":["sp_live_prepaid_resources"]}}'
    }
  }]
};